import React, { useEffect } from "react";

const Taxend = () => {
  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "//wcs.naver.net/wcslog.js";
    script1.type = "text/javascript";
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.innerHTML = `
      if (!wcs_add) var wcs_add = {};
      wcs_add["wa"] = "s_1f14cf3a248f";
      if (!_nasa) var _nasa = {};
      if (window.wcs) {
        wcs.inflow("smilevent.co.kr");
        wcs_do();
      }
    `;
    document.head.appendChild(script2);

    const script3 = document.createElement("script");
    script3.type = "text/javascript";
    script3.innerHTML = `
      if (window.wcs) {
        if (!wcs_add) var wcs_add = {};
        wcs_add['wa'] = 's_1f14cf3a248f';
        var _conv = {};
        _conv.type = 'lead';
        wcs.trans(_conv);
      }
    `;
    document.head.appendChild(script3);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
      document.head.removeChild(script3);
    };
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <h1 style={{ fontSize: "2em" }}>상담 신청이 완료되었습니다.</h1>
    </div>
  );
};

export default Taxend;
